/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import IClasificaciones from 'Infotrack@Modelos/smartStock/clasificaciones/entidades/clasificaciones';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorIndicadorCargaGlobal,
    manejadorDialogoGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import ClasificacionesCM from '../controladorModelo/clasificacionesCM';
import { acciones, IEstadoClasificaciones } from '../reductorClasificaciones';
import ClasificacionesVista from '../vista/tablaClasificacionesVista';
import Texto from '@infotrack/presentacion-componentes/texto';
import { useSelector } from 'react-redux';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';

const clasificacionesCM = new ClasificacionesCM();

const TableClasificacionesCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [clasificacioness, setClasificacioness] = React.useState<IClasificaciones[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoClasificaciones>();
    const idEmpresa = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdEmpresa);
    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarClasificaciones();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarClasificaciones = () => {
        manejadorIndicadorCargaGlobal(true);
        clasificacionesCM.consultarClasificacionesPorFiltro({EmpresaId:idEmpresa}).then((clasificacioness) => {
            setClasificacioness(clasificacioness);
            manejadorIndicadorCargaGlobal(false);
        });
    };
    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadClasificaciones?: IClasificaciones) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadClasificaciones, tipoFormulario } });
    };

    const confirmarEliminacion = (clasificaciones: IClasificaciones) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarClasificaciones(clasificaciones),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarClasificaciones = (clasificaciones: IClasificaciones) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        clasificacionesCM.eliminarClasificaciones(clasificaciones).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <ClasificacionesVista
            clasificacioness={clasificacioness}
            cargarClasificaciones={cargarClasificaciones}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableClasificacionesCV;
